import type ReactGridLayout from 'react-grid-layout';

export enum ContentTypes {
  Visual,
  Text,
  Markdown,
}

export const DASHBOARD_BACKGROUND_MODES = {
  NONE: 'none',
  SOLID: 'solid',
  GRADIENT: 'gradient',
} as const;

export type DashboardBackgroundMode = (typeof DASHBOARD_BACKGROUND_MODES)[keyof typeof DASHBOARD_BACKGROUND_MODES];

export interface DashboardGradientBackground {
  from: string;
  to: string;
  angle: number;
}

export interface DashboardBackgroundStyle {
  mode: DashboardBackgroundMode;
  solidColor?: string;
  gradient?: DashboardGradientBackground;
}

export const HEADER_HEIGHT = 6;

export interface DashboardContent {
  type: ContentTypes;
  /** user given name; prefilled on content insertion */
  title: string;
  /**  indicates if title should be displayed or not */
  showTitle: boolean;
  /**  indicates if a border should be displayed or not */
  showBorder?: boolean;
  /**  id of the content for the given tile */
  id: string;
  heading?: boolean;
  backgroundStyle?: DashboardBackgroundStyle | null;
}

export type DashboardTile = DashboardContent & ReactGridLayout.Layout;

export interface DashboardMenuAction {
  translationKey: string;
  action: () => Promise<void> | void;
  iconClass: string;
  isActive?: boolean;
}
